
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25","fill":"none"}},[_c('path',{attrs:{"d":"M7.293 12.793a1 1 0 011.414 0L11 15.086V3.5a1 1 0 112 0v11.586l2.293-2.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"}}),_c('path',{attrs:{"d":"M22 13.5a1 1 0 10-2 0v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6a1 1 0 10-2 0v6a3 3 0 003 3h14a3 3 0 003-3v-6z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      